import { SessionActions, SessionStore } from "stores/sessions/SessionStore";
const whenLoggedIn = (fn) => {
  if (SessionStore.isLoggedIn()) {
    fn();
    return;
  }
  const unsubscribe = SessionActions.login.completed.listen(() => {
    unsubscribe();
    fn();
  });
};
export default whenLoggedIn;
